import { Instagram } from "lucide-react";
import { LOGO_URL } from "@/lib/assets";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#06081C] text-[#F6F0E8] pt-16 pb-10 overflow-hidden border-t border-[#F6F0E8]/10"
    >
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full bg-[radial-gradient(ellipse,rgba(237,11,9,0.18),rgba(6,8,28,0)_70%)] blur-2xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center text-center gap-6">
          <div className="flex items-center gap-3">
            <img
              src={LOGO_URL}
              alt="Gullway Nibs"
              className="h-14 w-14 rounded-full object-cover ring-2 ring-[#F4A623]/60"
            />
            <div className="text-left">
              <div className="font-display text-3xl uppercase leading-none">
                Gullway <span className="text-[#ED0B09]">Nibs</span>
              </div>
              <div className="text-xs uppercase tracking-[0.3em] text-[#F4A623] mt-1">
                Best in the South East
              </div>
            </div>
          </div>

          <p className="text-sm text-[#F6F0E8]/65 max-w-md leading-relaxed">
            Taste of NZ nibbles, born in Burn City. One flavour, all killer. Cooked fresh,
            served crispy, devoured fast.
          </p>

          <div className="flex items-center gap-3">
            <a
              href="https://instagram.com/gullwaynibs"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              data-testid="footer-social-instagram"
              className="h-10 w-10 rounded-full bg-[#171D4F] border border-[#F6F0E8]/10 flex items-center justify-center hover:bg-[#ED0B09] hover:border-[#ED0B09] transition-colors"
            >
              <Instagram size={16} />
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#F6F0E8]/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#F6F0E8]/55 uppercase tracking-widest">
          <div>© {new Date().getFullYear()} Gullway Nibs. All rights reserved.</div>
          <div>Made hot in Burn City</div>
        </div>
      </div>
    </footer>
  );
}
